import { ElementRef, Injectable, Injector } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ComponentType, ConnectedPosition, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { IMenuPosition } from '@shared/constants/menu-positions';
import { switchMap, of } from 'rxjs';

@Injectable()
export class OverlayMenuService {


  constructor(private overlay: Overlay) {}

  getMenuRef(documentRef: MatButton) {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'fuse-backdrop-on-mobile',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay
        .position()
        // eslint-disable-next-line no-underscore-dangle
        .flexibleConnectedTo(documentRef._elementRef.nativeElement)
        .withLockedPosition(true)
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ]),
    });
  }
}

@Injectable()
export class JedsMenuService {
  private _overlayRef: OverlayRef;
  private _menuRef: JedsMenuRef;
  constructor(private _overlay: Overlay) {}

  /**
   *
   * @param component Componente a renderizar <ComponentType<any>>
   * @param elementRef Elemento de origen para renderizado <ElementRef>
   * @param data Data a enviar al overlay <any>
   * @returns
   */
  open(component: ComponentType<any>, elementRef: ElementRef, data?: any) {
    this._overlayRef = this.getMenuRef(elementRef);
    this._overlayRef.attach(
      new ComponentPortal(component, null, Injector.create({ providers: [{ provide: 'MAT_DIALOG_DATA', useValue: data }] }))
    );
    this._menuRef = new JedsMenuRef(this._overlayRef);
    return this._menuRef;
  }

  close(data?: any) {
    this._menuRef.close(data);
  }

  /**
   *
   * @param elementRef Elemento de origen para renderizado <ElementRef>
   * @returns Creacion de Overlay <OverlayRef>
   */
  private getMenuRef(elementRef: ElementRef) {
    let position: ConnectedPosition[];
    const init = elementRef.nativeElement.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
  
    //SI es Menor < se pone por arriba , si es Mayor > se pone abajo
    if (init.y < windowHeight / 2) {
      position = init.x < windowWidth / 2 ? IMenuPosition.topRight : IMenuPosition.topLeft;
    } else {
      position = init.x < windowWidth / 2 ? IMenuPosition.bottomRight : IMenuPosition.bottomLeft;
    }
  
    // Si el elemento está muy arriba y a la derecha, posicionar arriba a la derecha
    if (init.y < 0 && init.x > windowWidth / 2) {
      position = IMenuPosition.topRight;
    }
  
    // Si el elemento está abajo y a la derecha, posicionar arriba a la izquierda
    if (init.y > windowHeight / 2 && init.x > windowWidth / 2) {
      position = IMenuPosition.topLeft;
    }
  
    // Si el elemento está arriba y a la izquierda, posicionar a la derecha arriba
    if (init.y < 0 && init.x < windowWidth / 2) {
      position = IMenuPosition.topLeft;
    }
  
    // Si el elemento está abajo y a la izquierda, posicionar arriba a la derecha
    if (init.y > windowHeight / 2 && init.x < windowWidth / 2) {
      position = IMenuPosition.topRight;
    }
  
    return this._overlay.create({
      hasBackdrop: true,
      backdropClass: 'fuse-backdrop-on-mobile',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay
        .position()
        .flexibleConnectedTo(elementRef.nativeElement)
        .withLockedPosition(false)
        .withPush(true)
        .withPositions(position),
    });
  }
  
  


  getMenuRefFilter(documentRef: MatButton) {
    return this._overlay.create({
      hasBackdrop: true,
      backdropClass: 'fuse-backdrop-on-mobile',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay
        .position()
        // eslint-disable-next-line no-underscore-dangle
        .flexibleConnectedTo(documentRef._elementRef.nativeElement)
        .withLockedPosition(true)
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ]),
    });
  }
}

class JedsMenuRef extends JedsMenuService {
  private overlayRef: OverlayRef;
  private data: any;
  constructor(overlayRef: OverlayRef, private overlay?: Overlay) {
    super(overlay);
    this.overlayRef = overlayRef;
    this.overlayRef.backdropClick().subscribe({
      next: () => {
        this.overlayRef.detach();
      },
    });
  }

  afterClosed() {
    return this.overlayRef.detachments().pipe(switchMap(() => of(this.data)));
  }

  close(data: any) {
    this.data = data;
    this.overlayRef.detach();
  }
}
